"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SpinsHeader = SpinsHeader;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactMintl = require("@godaddy/react-mintl");
var _UIHelper = _interopRequireDefault(require("./UIHelper"));
var _utils = require("@site/utils");
function SpinsHeader({
  options = {}
}) {
  const {
    spinsHeader = {},
    styleOverrides: {
      spinsHeaderStyle = {}
    } = {}
  } = options;
  const {
    showOfferNotQualified,
    lpHeadline,
    searchStatus,
    spinHeaderExactMatchDomain,
    headerOverrideTextId
  } = spinsHeader;
  const getHeaderTextId = () => {
    if ((showOfferNotQualified || lpHeadline) && spinHeaderExactMatchDomain && !spinHeaderExactMatchDomain?.IsPurchasable) {
      return _UIHelper.default.getLpSpinHeader(spinHeaderExactMatchDomain);
    } else if (searchStatus === _utils.SEARCH_STATUS.Taken) {
      return 'selectedForYou';
    }
    return 'protectYourName';
  };
  return /*#__PURE__*/_react.default.createElement("h5", {
    "data-cy": "spins-header-standard",
    "data-testid": "spins-header-standard",
    className: "mt-3",
    style: spinsHeaderStyle
  }, /*#__PURE__*/_react.default.createElement(_reactMintl.FormattedMessage, {
    id: headerOverrideTextId || getHeaderTextId()
  }));
}
SpinsHeader.propTypes = {
  options: _propTypes.default.object
};